import { DocumentData } from "firebase/firestore";
import { UserProfile } from "../types/User";

export function mapSnapshotToUserProfile(
  id: string,
  snapshot: DocumentData
): UserProfile {
  return {
    userId: id,
    createdAt: snapshot.createdAt.toDate(),
    photoURL: snapshot.photoURL,
    username: snapshot.username,
    zipCode: snapshot.zipCode,
    pokesAvailable: snapshot.pokesAvailable,
    socials: snapshot.socials,
  };
}
